import React from "react";

// Component to style placeholders in purple
export default function EmailPlaceholderSpan({ children }) {
  return (
    <span
      style={{ color: "#6B43B5", boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)", padding: "3px 10px", margin: "0 5px", borderRadius: 10, fontSize: 12 }}
    >
      {children}
    </span>
  );
}
